import React from "react";
import FacebookContent from './../../Components/FacebookContent.jsx'
import ConfirmedOrderInfo from "./ConfirmedOrderInfo.jsx";


export default class OfflineCheckout extends React.Component {
	constructor(props) {
		super(props);
	}

	render = () => {
		let T = window.Texts.checkout;
		return (
			<div className="checkout-page">
				<div className="cover">
					<div class="headline">
						<div class="succcess-ordered">
							{T.successFinish}
						</div>
						<h1 dangerouslySetInnerHTML={{ __html: T.bankInfo }} />
						<div style={{ color: 'red', fontSize: '2rem', fontWeight: 'bold', lineHeight: '4rem' }}>
							{T.offlineNotice}
						</div>
					</div>
					<div class="checkout-inner submit-order">
						<div className="sub_text" dangerouslySetInnerHTML={{ __html: T.thankforOrder }} />
						<FacebookContent />
						<ConfirmedOrderInfo
							confirmedOrder={this.props.confirmedOrder}
							invoiceContact={this.props.invoiceContact}
							deliveryContact={this.props.deliveryContact}
						/>
					</div>
				</div>
			</div>);
	}
}

